import { render, staticRenderFns } from "./SupportEmail.vue?vue&type=template&id=38ac8728&"
import script from "./SupportEmail.vue?vue&type=script&lang=ts&"
export * from "./SupportEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports